/* ============================================
   Cart Drawer - AJAX Cart with Section Rendering
   ============================================ */

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('[data-cart-overlay]');
    this.closeBtn = this.querySelector('[data-cart-close]');
    this.body = this.querySelector('[data-cart-body]');
    this.removeFocusTrap = null;
  }

  connectedCallback() {
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    });

    FuzeTheme.FuzeEvents.on('cart:toggle', () => this.toggle());
    FuzeTheme.FuzeEvents.on('cart:updated', () => this.refresh());

    this.setupCartActions();
  }

  open() {
    this.setAttribute('aria-hidden', 'false');
    FuzeTheme.lockScroll();
    this.removeFocusTrap = FuzeTheme.trapFocus(this, this.closeBtn);
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    FuzeTheme.unlockScroll();
    this.removeFocusTrap?.();
  }

  toggle() {
    if (this.getAttribute('aria-hidden') === 'false') {
      this.close();
    } else {
      this.open();
    }
  }

  async refresh() {
    try {
      const html = await FuzeTheme.fetchSection('cart-drawer');
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newBody = doc.querySelector('[data-cart-body]');
      const newFooter = doc.querySelector('[data-cart-footer]');
      const oldFooter = this.querySelector('[data-cart-footer]');

      if (newBody) this.body.innerHTML = newBody.innerHTML;
      if (newFooter && oldFooter) {
        oldFooter.innerHTML = newFooter.innerHTML;
      } else if (newFooter && !oldFooter) {
        this.querySelector('.cart-drawer__inner').appendChild(newFooter.cloneNode(true));
      } else if (!newFooter && oldFooter) {
        oldFooter.remove();
      }

      this.setupCartActions();
    } catch (error) {
      console.error('Cart refresh error:', error);
    }
  }

  setupCartActions() {
    // Quantity buttons
    this.querySelectorAll('[data-cart-item]').forEach(item => {
      const line = parseInt(item.dataset.lineIndex);
      const minusBtn = item.querySelector('[data-cart-quantity-minus]');
      const plusBtn = item.querySelector('[data-cart-quantity-plus]');
      const input = item.querySelector('[data-cart-quantity-input]');
      const removeBtn = item.querySelector('[data-cart-remove]');

      minusBtn?.addEventListener('click', () => {
        const qty = parseInt(input.value) || 1;
        this.updateLine(line, Math.max(0, qty - 1));
      });

      plusBtn?.addEventListener('click', () => {
        const qty = parseInt(input.value) || 1;
        this.updateLine(line, qty + 1);
      });

      input?.addEventListener('change', () => {
        const qty = parseInt(input.value) || 0;
        this.updateLine(line, Math.max(0, qty));
      });

      removeBtn?.addEventListener('click', () => {
        this.updateLine(line, 0);
      });
    });
  }

  async updateLine(line, quantity) {
    try {
      const cart = await FuzeTheme.CartAPI.change(line, quantity);
      FuzeTheme.FuzeEvents.emit('cart:updated', { cart });
    } catch (error) {
      console.error('Cart update error:', error);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);
